/** @file pictureRound: where the drawn picture puts a quad edge or a point, in target pixels. */

/**
 * The picture's pixel rules (the runtime's fragment shader = raster's `fillQuad`): a target pixel is drawn when its
 * centre `(i + 0.5, j + 0.5)` lies in the quad, left / top edges inclusive, right / bottom exclusive.
 *
 * `edge(v)`: a quad edge at `v` (px) shows as the pixel boundary `ceil(v - 0.5)`, the rim of the drawn pixels on
 * either side. `point(v, f)`: a point drawn at fraction `f` of a pixel (the impostor's display pivot fraction:
 * 0.5 for a half-pixel pivot, 0 for a whole one) shows at `edge(v - f) + f`, the spot the tile's pivot lands on when
 * its corners are `v - pivot`. With `f = 0.5` that is `ceil(v) - 0.5`, the centre of pixel `ceil(v) - 1` (a point on a
 * boundary belongs to the pixel on its left / above), the server overlay's joint pixel.
 */
export const pictureRound = {
  edge: (v: number): number => Math.ceil(v - 0.5) + 0,
  point: (v: number, f: number): number => Math.ceil(v - f - 0.5) + f + 0,
} as const;
